import moment from "moment";

export const parseDate = raw => {
  let rawSplit = raw.split(" ")[0].split("/");
  let date = moment(new Date);
  date.set({'year': rawSplit[2], 'month': rawSplit[1] - 1, date: rawSplit[0]});
  return date;
}